import { z } from "zod";

const GENDER_ERROR_MESSAGE = "Please select your gender";

// Gender Schema - errorMap handles all error types including invalid_type for null values
export const genderSchema = z.enum(["male", "female"], {
    errorMap: () => ({ message: GENDER_ERROR_MESSAGE }),
});
